  export const channelMap = {
    CH1: 1,
    CH2: 2,
    CH3: 4,
    CH4: 8,
    CH5: 16,
    CH6: 32,
    CH7: 64,
    CH8: 128,
    CH9: 256,
    CH10: 512,
    CH11: 1024,
    CH12: 2048
  } 

export const numChannelMap = {
  1: "CH1",
  2: "CH2",
  4: "CH3",
  8: "CH4",
  16: "CH5",
  32: "CH6",
  64: "CH7",
  128: "CH8",
  256: "CH9",
  512: "CH10",
  1024: "CH11",
  2048: "CH12"
}

const channelToNumber = (ch) => { 
  return channelMap[ch] || 0
}

const channelsToMask = (arr = []) => {
  return (arr || []).reduce((m, ch) => m | channelToNumber(ch), 0)
}

const previewModeToCode = (mode) => {
  const match = mode.match(/^Model(\d+)$/)
  return match ? Number(match[1]) : 0
}

export const transformToPayload = (formData) => {
  if (formData.action === 'DMS') {
    const alarmTypeMap = {
      call: 'call',
      smoking: 'smoke',
      eyes_closed: 'close_eyes',
      close_eys_serious: 'close_eys_serious',
      yawning: 'yawn',
      yawn_serious: 'yawn_serious',
      distracted: 'distract_driving',
      no_driver: 'driver_abnormal',
      infrared: 'ir_blocking',
      seat_belt: 'seatbelt_unfastened',
      camera_cover: 'lens_covered',
      fatigue_driving: 'fatigue_driving',
    }

    const alarm_settings = formData.dms.alarms.map(alarm => {
      const linkage = alarm.linkage || {}
      return {
        type: alarmTypeMap[alarm.key] || alarm.key,
        speed: 0,
        state: alarm.state,
        threshold: alarm.threshold,
        interval: alarm.interval,
        alm_triger_pre_recording: alarm.pre_record,
        alm_triger_hold_time: alarm.alarm_trigger,
        coefficient: alarm.keeptime,
        record: linkage.start_record ?? 1,
        link_buzzer: linkage.voice_broadcast ?? 1,
        link_preview_mode: previewModeToCode(linkage.preview_mode || 'Model2'),
        link_lock_chn: channelsToMask(linkage.video_lock),
        link_video_upload_chn: channelsToMask(linkage.video_upload),
        link_output: linkage.link_output ? 1 : 0,
        link_snap_chn: channelsToMask(linkage.snapshot_upload),
        link_preview_chn: channelsToMask(linkage.preview),
        out1_time: linkage.out1_output_time,
        keeptime: alarm.keeptime,
      }
    })

    return {
      device_code: formData.deviceType,
      type: 'dms',
      i_manual_set: formData.dms.iManualSet,
      pitch_down: formData.dms.pitch_down,
      pitch_up: formData.dms.pitch_up,
      yaw_left: formData.dms.yaw_left,
      yaw_right: formData.dms.yaw_right,
      draw_en: formData.dms.draw_en,
      profile_name: formData.profileName,
      chn: channelToNumber(formData.dms.videoChannel),
      installation: formData.dms.installation === 'default' ? 0 : formData.dms.installation === 'left' ? 1 : 2,
      install_self_check: formData.dms.installSelfCheck,
      alarm_settings,
      changes: formData?.changes ?? [],
    }
  } else if (formData.action === 'ADAS') {
    const alarmTypeMap = {
      fcw: 'fcw',
      hmw: 'hmw',
      ldw: 'ldw',
      pcw: 'pcw',
    }

    const alarm_settings = formData.adas.alarms.map(alarm => {
      const linkage = alarm.linkage || {}
      return {
        type: alarmTypeMap[alarm.key] || alarm.key,
        speed: alarm.speed,
        state: alarm.state,
        threshold: 0,
        interval: alarm.interval,
        alm_triger_pre_recording: alarm.pre_record,
        alm_triger_hold_time: alarm.alarm_trigger,
        sensitivity: alarm.sensitivity,
        coefficient: 0,
        record: linkage.start_record ?? 1,
        link_buzzer: linkage.voice_broadcast ?? 1,
        link_preview_mode: previewModeToCode(linkage.preview_mode || 'Model2'),
        link_lock_chn: channelsToMask(linkage.video_lock),
        link_video_upload_chn: channelsToMask(linkage.video_upload),
        link_output: linkage.link_output ? 1 : 0,
        link_snap_chn: channelsToMask(linkage.snapshot_upload),
        link_preview_chn: channelsToMask(linkage.preview),
        out1_time: linkage.out1_output_time,
        keeptime: 0,
      }
    })

    return {
      device_code: formData.deviceType,
      type: 'adas',
      profile_name: formData.profileName,
      chn: channelToNumber(formData.adas.videoChannel),
      installation: 0,
      i_manual_set: 0,
      pitch_down: 10,
      pitch_up: 15,
      yaw_left: 5,
      yaw_right: 5,
      draw_en: formData.adas.draw_en,
      install_self_check: formData.adas.installSelfCheck,
      cam_height: formData.adas.calibration.cameraHeight,
      cam_to_center: formData.adas.calibration.cameraToCenterline,
      vehicle_width: formData.adas.calibration.vehicleWidth,
      cam_to_bumper: formData.adas.calibration.cameraToBumper,
      cam_to_axle: formData.adas.calibration.cameraToAxle,
      horizon_line: formData.adas.other.horizonPixel,
      centerline: formData.adas.other.centerlinePixel,
      bottom_extra_width: formData.adas.calibration.bottomExtraWidth,
      brake_time: formData.adas.calibration.brakeTime,
      i_camera_to_left_wheel: formData.adas.calibration.iCameraToLeftWheel,
      alarm_settings,
      changes: formData?.changes ?? [],
    }
  }
}
